import { render, staticRenderFns } from "./sftp-settings.vue?vue&type=template&id=fe07c7f6&scoped=true"
import script from "./sftp-settings.vue?vue&type=script&lang=js"
export * from "./sftp-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe07c7f6",
  null
  
)

export default component.exports